import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useEffect, useReducer, useMemo } from 'react'; // import { IntlProvider } from 'react-intl';

import moment from 'moment-timezone';
import { isPhoneDevice } from '@mummssoftware/utils/web';
import { getNonReviewForms, mapDoctorsOptions } from '@mummssoftware/utils/utils';
import { getPatientDateRestrictions } from './utils';
import { SET_APP_VISIT, SET_EDITING_PAST_VISIT, SET_LEVEL_OF_CARE, ADD_FORM, OPEN_WIDGET, CLOSE_WIDGET, SET_WIDGET_NAMES_OPEN, SET_GLOBAL_DOCTORS, SET_MEDS, SET_CARE_PLAN_FREQUENCIES, SET_PATIENT_SUBMITTED_CPP_LIST, SET_GLOBAL_PATIENT, SET_GLOBAL_MEASURES, SET_FAJITA_FORM, REFRESH_GLOBAL_CONTEXT, SET_GENERAL_STANDING_ORDER, SET_PATIENT_STANDING_ORDERS, REFRESH_PN_WIDGET, SET_CROSS_PATIENT_WIP_FORMS, SET_COMPLETED_FORMS, SET_IN_PROGRESS_FORMS, SET_FAJITA_WARNING, SET_PATIENT_DATE_RESTRICTIONS, RESET_ADMIN_DATE_RESTRICTIONS, RELOAD_MANIFEST, RELOAD_MEASURES, SET_ATTEMPTED_VISIT_NOTE, SET_APP_VISIT_DETAILS, SET_AG_GRID_COLUMN_STATE, SET_AG_GRID_SELECTED_ROWS, SET_FAX_LIST, SET_EMAIL_LIST } from './constants';
const initialState = {
  appVisit: undefined,
  editingPastVisit: undefined,
  appVisitDetails: null,
  levelOfCare: null,
  numberForms: 0,
  widgetNamesOpen: [],
  widgetsOpen: {},
  widgetsFilter: {},
  medsGlobal: null,
  doctorsGlobal: null,
  carePlanFrequenciesGlobal: null,
  patientSubmittedCPPListGlobal: null,
  patientGlobal: null,
  measuresGlobal: null,
  generalStandingOrderGlobal: null,
  patientStandingOrdersGlobal: null,
  fajitaFormGlobal: null,
  displayFajitaWarning: false,
  crossPatientWIPForms: null,
  completedPatientForms: [],
  inProgressPatientForms: [],
  patientDateRestrictions: null,
  globalPatientCPPTasks: null,
  resetAdminDateRestrictions: false,
  refreshPN: false,
  reloadManifest: 0,
  reloadMesures: 0,
  attemptedVisitNote: null,
  agGridColumnState: null,
  agGridSelectedRows: null,
  siteFaxList: null,
  siteEmailList: null
};
const initGlobalContext = {
  appVisit: undefined,
  editingPastVisit: undefined,
  appVisitDetails: null,
  levelOfCare: null,
  numberForms: 0,
  widgetNamesOpen: [],
  widgetsOpen: {},
  widgetsFilter: {},
  medsGlobal: null,
  doctorsGlobal: null,
  carePlanFrequenciesGlobal: null,
  patientSubmittedCPPListGlobal: null,
  patientGlobal: null,
  measuresGlobal: null,
  generalStandingOrderGlobal: null,
  patientStandingOrdersGlobal: null,
  fajitaFormGlobal: null,
  displayFajitaWarning: false,
  crossPatientWIPForms: null,
  completedPatientForms: [],
  inProgressPatientForms: [],
  patientDateRestrictions: null,
  globalPatientCPPTasks: null,
  resetAdminDateRestrictions: false,
  refreshPN: false,
  reloadManifest: 0,
  reloadMesures: 0,
  attemptedVisitNote: null,
  agGridColumnState: null,
  agGridSelectedRows: null,
  siteFaxList: null,
  siteEmailList: null
};
export const GlobalContextReducer = (state, action) => {
  var _action$payload;

  let newState = _objectSpread({}, state);

  switch (action.type) {
    // Dashboard and Forms
    case SET_APP_VISIT:
      newState.appVisit = action.payload;
      break;
    // Dashboard and Forms

    case SET_LEVEL_OF_CARE:
      newState.levelOfCare = action.payload;
      break;
    // Dashboard and Forms

    case ADD_FORM:
      newState.numberForms += 1;
      break;

    case SET_WIDGET_NAMES_OPEN:
      newState.widgetNamesOpen = [];
      break;

    case OPEN_WIDGET:
      {
        const name = action.payload.componentName;
        newState.widgetsOpen[name] = action.payload;
        newState.widgetNamesOpen = Object.keys(newState.widgetsOpen);

        if (action.payload.filter) {
          newState.widgetsFilter[name] = action.payload.filter;
        }
      }
      break;

    case CLOSE_WIDGET:
      {
        const name = action.payload.componentName;
        delete newState.widgetsOpen[name];
        delete newState.widgetsFilter[name];
        newState.widgetNamesOpen = Object.keys(newState.widgetsOpen);
      }
      break;
    // DASHBOARD and PN

    case SET_GLOBAL_PATIENT:
      newState.patientGlobal = action.payload;
      break;
    // PN CONTEXT and MEDS

    case SET_GLOBAL_DOCTORS:
      newState.doctorsGlobal = mapDoctorsOptions(action.payload);
      break;
    // PN CONTEXT and MEDS

    case SET_MEDS:
      newState.medsGlobal = action.payload;
      break;
    // CARE_PLAN_FREQUENCIES and PN Context

    case SET_CARE_PLAN_FREQUENCIES:
      newState.carePlanFrequenciesGlobal = action.payload;
      break;
    // CARE PLAN PROBLEMS for PN Context
    // @note list of patient CPP Submitted - excludes WIP and Resolved (not heavy API call)

    case SET_PATIENT_SUBMITTED_CPP_LIST:
      newState.patientSubmittedCPPListGlobal = action.payload;
      break;
    // PN and Dashboard

    case SET_PATIENT_STANDING_ORDERS:
      newState.patientStandingOrdersGlobal = action.payload;
      break;
    // PN and Visit Frequency

    case SET_GENERAL_STANDING_ORDER:
      newState.generalStandingOrderGlobal = action.payload;
      break;
    // Forms, no Forms Global Context

    case SET_FAJITA_FORM:
      newState.fajitaFormGlobal = action.payload; //! TEMP WARNING FOR SANDBOX FORMS
      // todo issandboxform

      newState.displayFajitaWarning = ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.issandboxform) || false;
      break;

    case SET_FAJITA_WARNING:
      newState.displayFajitaWarning = action.payload;
      break;
    // PN and Dashboard

    case REFRESH_PN_WIDGET:
      newState.refreshPN = action.payload;
      break;

    case REFRESH_GLOBAL_CONTEXT:
      newState.carePlanFrequenciesGlobal = null;
      newState.measuresGlobal = null;
      newState.medsGlobal = null;
      break;
    // CPP, Frequency, measures, meds

    case SET_PATIENT_DATE_RESTRICTIONS:
      newState.patientDateRestrictions = action.payload;
      break;

    case RESET_ADMIN_DATE_RESTRICTIONS:
      newState.resetAdminDateRestrictions = action.payload;
      break;
    // only in measures

    case SET_GLOBAL_MEASURES:
      newState.measuresGlobal = action.payload;
      break;
    // only in cross patient forms

    case SET_CROSS_PATIENT_WIP_FORMS:
      newState.crossPatientWIPForms = getNonReviewForms(action.payload);
      break;

    case SET_COMPLETED_FORMS:
      newState.completedPatientForms = action.payload;
      break;

    case SET_IN_PROGRESS_FORMS:
      newState.inProgressPatientForms = action.payload;
      break;
    // manifest no data in global context, reset key to refresh data

    case RELOAD_MANIFEST:
      newState.reloadManifest += 1;
      break;

    case RELOAD_MEASURES:
      newState.reloadMesures += 1;
      break;

    case SET_APP_VISIT_DETAILS:
      newState.appVisitDetails = action.payload;
      break;

    case SET_AG_GRID_COLUMN_STATE:
      newState.agGridColumnState = action.payload;
      break;

    case SET_AG_GRID_SELECTED_ROWS:
      newState.agGridSelectedRows = action.payload;
      break;

    case SET_EDITING_PAST_VISIT:
      newState.editingPastVisit = action.payload;
      break;

    case SET_ATTEMPTED_VISIT_NOTE:
      newState.attemptedVisitNote = action.payload;
      break;

    case SET_FAX_LIST:
      newState.siteFaxList = action.payload;
      break;

    case SET_EMAIL_LIST:
      newState.siteEmailList = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const GlobalContext = /*#__PURE__*/createContext(initGlobalContext);
export const GlobalDispatchContext = /*#__PURE__*/createContext({});
export const GlobalContextConsumer = GlobalContext.Consumer;
export const GlobalDispatchContextConsumer = GlobalDispatchContext.Consumer;
export const GlobalContextProvider = ({
  children,
  keycloak,
  agency,
  patient,
  currentUser,
  pim
}) => {
  const [{
    appVisit,
    editingPastVisit,
    appVisitDetails,
    levelOfCare,
    numberForms,
    widgetsOpen,
    widgetNamesOpen,
    widgetsFilter,
    doctorsGlobal,
    medsGlobal,
    carePlanFrequenciesGlobal,
    patientSubmittedCPPListGlobal,
    patientGlobal,
    measuresGlobal,
    generalStandingOrderGlobal,
    patientStandingOrdersGlobal,
    fajitaFormGlobal,
    displayFajitaWarning,
    crossPatientWIPForms,
    completedPatientForms,
    inProgressPatientForms,
    patientDateRestrictions,
    globalPatientCPPTasks,
    resetAdminDateRestrictions,
    refreshPN,
    reloadManifest,
    reloadMesures,
    attemptedVisitNote,
    agGridColumnState,
    agGridSelectedRows,
    siteFaxList,
    siteEmailList
  }, dispatch] = useReducer(GlobalContextReducer, initialState);
  const numOpenWidgets = widgetNamesOpen.length;
  const isPhone = isPhoneDevice();
  /**
   * Set the default timezone to the site timezone for all widgets
   */

  const tz = moment.tz.guess();
  const siteTimezone = currentUser && currentUser.siteTimezone || tz;
  moment.tz.setDefault(siteTimezone);
  useEffect(() => {
    if (patient && !patientGlobal) {
      dispatch({
        type: SET_GLOBAL_PATIENT,
        payload: patient
      });
    }
  }, [patient]);
  useEffect(() => {
    if (patientGlobal) {
      getDateRestrictions();
    }
  }, [patientGlobal]);
  useEffect(() => {
    if (pim) {
      getPNPatient();
    }
  }, [pim]);
  useEffect(() => {
    if (isPhone) {
      if (numOpenWidgets > 2) {
        // close the first widget open
        const widgetToClose = widgetNamesOpen[0];
        dispatch({
          type: CLOSE_WIDGET,
          payload: {
            componentName: widgetToClose
          }
        });
      }
    }

    if (numOpenWidgets > 4) {
      // close the first widget open
      const widgetToClose = widgetNamesOpen[0];
      dispatch({
        type: CLOSE_WIDGET,
        payload: {
          componentName: widgetToClose
        }
      });
    }
  }, [numOpenWidgets]);
  /**
   * Set Global Patient to work from PN stand alone widget
   */

  const getPNPatient = async () => {
    if (pim && !patientGlobal) {
      const patientNumber = window.location.pathname.substring(1).split('/')[0];
      const pnPatient = await pim.getPatientHeader(patientNumber);

      if (!(pnPatient instanceof Response)) {
        dispatch({
          type: SET_GLOBAL_PATIENT,
          payload: pnPatient
        });
      }
    }
  };

  const getDateRestrictions = async () => {
    if (keycloak && agency && patientGlobal && currentUser) {
      const dateRestrictions = await getPatientDateRestrictions(keycloak, agency, patientGlobal, currentUser);
      dispatch({
        type: SET_PATIENT_DATE_RESTRICTIONS,
        payload: dateRestrictions
      });
    }
  };

  const resetDateRestrictions = () => {
    if (patientDateRestrictions) {
      const dateRestrictions = patientDateRestrictions;
      dateRestrictions.basicDateConstraint = patientDateRestrictions.admissionDate;
      dispatch({
        type: SET_PATIENT_DATE_RESTRICTIONS,
        payload: dateRestrictions
      });
    }
  };

  useEffect(() => {
    if (resetAdminDateRestrictions) {
      resetDateRestrictions();
    }
  }, [resetAdminDateRestrictions]);
  const context = useMemo(() => ({
    appVisit,
    editingPastVisit,
    appVisitDetails,
    levelOfCare,
    numberForms,
    widgetsOpen: Object.values(widgetsOpen),
    widgetNamesOpen,
    widgetsFilter,
    doctorsGlobal,
    medsGlobal,
    carePlanFrequenciesGlobal,
    patientSubmittedCPPListGlobal,
    patientGlobal,
    measuresGlobal,
    generalStandingOrderGlobal,
    patientStandingOrdersGlobal,
    fajitaFormGlobal,
    displayFajitaWarning,
    refreshPN,
    crossPatientWIPForms,
    completedPatientForms,
    inProgressPatientForms,
    patientDateRestrictions,
    globalPatientCPPTasks,
    resetAdminDateRestrictions,
    reloadManifest,
    reloadMesures,
    attemptedVisitNote,
    agGridColumnState,
    agGridSelectedRows,
    siteFaxList,
    siteEmailList,
    dispatch
  }), [appVisit, editingPastVisit, appVisitDetails, levelOfCare, numberForms, widgetsOpen, widgetNamesOpen, widgetsFilter, doctorsGlobal, medsGlobal, carePlanFrequenciesGlobal, patientSubmittedCPPListGlobal, patientGlobal, measuresGlobal, generalStandingOrderGlobal, patientStandingOrdersGlobal, fajitaFormGlobal, displayFajitaWarning, refreshPN, crossPatientWIPForms, completedPatientForms, inProgressPatientForms, patientDateRestrictions, globalPatientCPPTasks, resetAdminDateRestrictions, reloadManifest, reloadMesures, attemptedVisitNote, agGridColumnState, agGridSelectedRows, siteFaxList, siteEmailList, dispatch]);
  return /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: context
  }, children) // <GlobalContext.Provider value={context}>
  //   <IntlProvider locale="en" messages={{}}>
  //     {children}
  //   </IntlProvider>
  // </GlobalContext.Provider>
  ;
};
export function withGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(GlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(GlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default GlobalContext;